import { h } from 'preact';

const Govx = () => {
  const popup = (e, n = 450, t = 700, r = window, i = document) => {
    e = (e && e.href) || e;
    let o = (i = i.documentElement).clientWidth;
    const iHeight = i.clientHeight;
    let c = r.innerWidth;
    const l = r.innerHeight;
    let p = r.screenLeft;
    let u = r.screenTop;
    p = p !== null ? p : r.screenX;
    u = u !== null ? u : r.screenY;
    // eslint-disable-next-line no-restricted-globals
    c = (c || o || screen.width) / 2 - n / 2 + p;
    // eslint-disable-next-line no-restricted-globals
    o = (l || iHeight || screen.height) / 2 - t / 2 + u;
    p = r.open(
      e,
      'GovX ID Authorization',
      `width=${n},height=${t},top=${o},left=${c}`,
    );
    return p;
  };

  return (
    <i className="govx-id-slim-wrapper">
      <style
        dangerouslySetInnerHTML={{
          __html:
            "[data-govx-id]{width:100%;}[data-govx-id] .govx-id-text{fill:#231f20;}[data-govx-id] .govx-id-shield{fill:#ee6337;}.govx-id-slim-wrapper{font-style:normal;clear:both;display:block !important;width:100%;padding:10px 0 0 !important;letter-spacing:initial;text-transform:none;}.govx-id-slim-wrapper .govx-id-slim{display:flex !important;}.govx-id-slim-wrapper.govx-sides{width:calc(100% - 40px);padding:20px 20px !important;}.govx-id-slim-wrapper.govx-max .govx-id-slim a{max-width:350px !important;}.govx-id-slim-wrapper.govx-left .govx-id-slim{justify-content:flex-start;}.govx-id-slim-wrapper.govx-center .govx-id-slim{justify-content:center;}.govx-id-slim-wrapper.govx-right .govx-id-slim{justify-content:flex-end;}[data-product-menu-state=\\'addtocart\\'] .product-menu-slideout [data-govx-id=\\'slim\\'].govx-id-slim-wrapper{display:none !important;}.header .mini-cart .mini-cart__recap .govx-id-slim-wrapper{padding:20px 0 0 0 !important;}.govx-id-slim-wrapper .govx-id-slim a{display:flex;width:100% !important;border:1px solid #eee;color:#333 !important;background-color:white !important;flex-direction:row;padding:10px;justify-content:flex-start;text-align:left;text-decoration:none;}.govx-id-slim img{width:50px;height:50px;max-width:50px;}.govx-id-slim i{display:block;flex-grow:0;align-self:center;width:60px;min-width:60px;height:50px;background-image:url(https://i5.govx.net/images/644224_govxid_new_logo_shopify_iapp_icon.svg?v=sQZpXJ91ehIbui8BnZNMVw==);background-repeat:no-repeat;}.govx-id-slim .govx-icon{display:block;flex-grow:0;align-self:center;width:50px;height:50px;}.govx-id-slim .govx-text{display:block;flex-grow:2;flex-wrap:wrap;align-self:center;padding-left:15px;max-width:400px;}.govx-id-slim .govx-text p{color:#333;line-height:16px;font-size:14px;margin:0px;}.govx-id-slim .govx-text span{font-weight:400;font-size:13px;white-space:normal;font-family:sans-serif;}",
        }}
      />
      <span className="govx-id-slim">
        <a
          title="GovX ID Link"
          target="popup"
          data-action="govx-id-pop"
          onClick={(e) => {
            e.preventDefault();
            popup(
              'https://auth.govx.com/shopify/verify?shop=benchmade-prod.myshopify.com&utm_source=shopify&utm_medium=govxid&utm_campaign=offer_button',
            );
          }}
          href="https://auth.govx.com/shopify/verify?shop=benchmade-prod.myshopify.com&utm_source=shopify&utm_medium=govxid&utm_campaign=cart_drawer"
        >
          <span className="govx-icon">
            <i />
          </span>
          <span className="govx-text">
            <p>
              <span>
                Military, First Responder, Government Employee and Teacher
                discount available
              </span>
            </p>
          </span>
        </a>
      </span>
    </i>
  );
};

export default Govx;
